<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="sectorswidget__background module__background"
        ></app-modulebackground>
        <div
            class="sectorswidget__container module__container"
            v-bind:class="{ container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type) }"
        >
            <div class="sectorswidget__inner module__inner">
                <div class="sectorswidget__inner--main module__inner--main">
                    <div
                        class="sectorswidget__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="sectorswidget__inner-col module__inner-col">
                            <div class="sectorswidget__header module__header">
                                <h2
                                    class="sectorswidget__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="sectorswidget__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="sectorswidget__inner-row module__inner-row">
                        <div class="sectorswidget__inner-col module__inner-col">
                            <div class="sectorswidget__content-block module__content-block">
                                <div
                                    class="sectorswidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="sectorswidget__inner-row module__inner-row">
                                        <div class="sectorswidget__inner-col module__inner-col">
                                            <div
                                                class="sectorswidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="sectorswidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="sectorswidget__inner-row module__inner-row">
                                        <div class="sectorswidget__inner-col module__inner-col">
                                            <div
                                                ref="slider"
                                                per-page="3"
                                                per-page-lg="2"
                                                per-page-md="1"
                                                per-page-sm="1"
                                                class="sectorswidget__sectors-images"
                                                v-bind:class="{
                                                    slider:
                                                        [5, 6].includes(module.layout.type) &&
                                                        items.length > 3
                                                }"
                                            >
                                                <ul
                                                    class="sectorswidget__sectors-list module__list"
                                                >
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="sectorswidget__sectors-item module__list-item"
                                                        v-bind:class="{
                                                            'col__width--one-quarter': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'col__width--one-third': [
                                                                3,
                                                                4
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="sectorswidget__teaser-box"
                                                            v-bind:class="{
                                                                'module__teaser-box--horizontal': [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <component
                                                                :is="
                                                                    getPageUrlFromType('sectors')
                                                                        ? 'a'
                                                                        : 'span'
                                                                "
                                                                v-on:click.prevent="
                                                                    scrollInsideEditor
                                                                "
                                                                v-bind:href="
                                                                    getPageUrlFromType('sectors')
                                                                        ? getPageUrlFromType(
                                                                              'sectors'
                                                                          ) +
                                                                          '/#' +
                                                                          items__value.id
                                                                        : null
                                                                "
                                                                v-bind:class="{
                                                                    'sectorswidget__teaser-box-inner module__teaser-box-inner module__link': [
                                                                        1,
                                                                        2,
                                                                        3,
                                                                        4,
                                                                        5,
                                                                        6
                                                                    ].includes(module.layout.type)
                                                                }"
                                                            >
                                                                <app-moduleicon
                                                                    v-if="
                                                                        items__value.data &&
                                                                            [1, 2, 3, 4].includes(
                                                                                module.layout.type
                                                                            )
                                                                    "
                                                                    :data="
                                                                        items__value.data.icon || {
                                                                            id: getRandomButDeterminedImageInNamespaceBasedOnUser(
                                                                                'icons/sectors/default',
                                                                                items__value.id
                                                                            )
                                                                        }
                                                                    "
                                                                    :custom-class="
                                                                        'sectorswidget__teasers-icon module__icon'
                                                                    "
                                                                ></app-moduleicon>

                                                                <app-moduleimage
                                                                    v-if="
                                                                        [5, 6].includes(
                                                                            module.layout.type
                                                                        ) &&
                                                                            items__value.data &&
                                                                            items__value.data.image
                                                                    "
                                                                    :data="items__value.data.image"
                                                                    :tag="'img'"
                                                                    :custom-class="
                                                                        'sectorswidget__teasers-image module__image'
                                                                    "
                                                                ></app-moduleimage>

                                                                <div
                                                                    class="sectorswidget__teasers-image module__image"
                                                                    v-if="
                                                                        items__value.data &&
                                                                            !items__value.data
                                                                                .image &&
                                                                            [5, 6].includes(
                                                                                module.layout.type
                                                                            )
                                                                    "
                                                                >
                                                                    <img
                                                                        v-bind:src="
                                                                            module.appearance
                                                                                .color == 1
                                                                                ? generateMediaUrl({
                                                                                      path:
                                                                                          'media/images/sectorswidget/default/2.jpg'
                                                                                  })
                                                                                : generateMediaUrl({
                                                                                      path:
                                                                                          'media/images/sectorswidget/default/1.jpg'
                                                                                  })
                                                                        "
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div
                                                                    class="sectorswidget__teaser-box-text module__teaser-box-text"
                                                                >
                                                                    <span
                                                                        class="sectorswidget__teasers-label module__label font-bold color-p"
                                                                        v-if="
                                                                            items__value.data &&
                                                                                items__value.data
                                                                                    .title
                                                                        "
                                                                        v-html="
                                                                            items__value.data.title
                                                                        "
                                                                    ></span>
                                                                    <span
                                                                        class="sectorswidget__teasers-label module__label font-bold color-p"
                                                                        v-else-if="
                                                                            items__value.data &&
                                                                                items__value.data
                                                                                    .name
                                                                        "
                                                                        v-html="
                                                                            items__value.data.name
                                                                        "
                                                                    ></span>
                                                                </div>
                                                            </component>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="sectorswidget__inner-row module__inner-row"
                        v-if="getPageUrlFromType('sectors')"
                    >
                        <div class="sectorswidget__inner-col module__inner-col">
                            <div class="sectorswidget__cta module__cta">
                                <app-modulebutton
                                    :href="getPageUrlFromType('sectors')"
                                    :custom-class="
                                        'sectorswidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                >
                                    Erfahren Sie mehr
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleicon': ModuleIcon,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        ...mapActions(['scrollInsideEditor'])
    },
    computed: {
        ...mapGetters([
            'getListItems',
            'getPageUrlFromType',
            'generateMediaUrl',
            'getRandomButDeterminedImageInNamespaceBasedOnUser'
        ]),
        items() {
            return this.getListItems('deha.user.misc.sectors');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
